import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivity = ({ activities }) => {
  // ✅ ADDED: Console logging to debug activity rendering
  console.log('📊 RecentActivity received activities:', activities);

  const getActivityIcon = (type) => {
    switch (type) {
      case 'created':
        return 'Plus';
      case 'edited':
        return 'Edit';
      case 'downloaded':
        return 'Download';
      case 'shared':
        return 'Share';
      case 'deleted':
        return 'Trash2';
      default:
        return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'created':
        return 'text-success';
      case 'edited':
        return 'text-primary';
      case 'downloaded':
        return 'text-accent';
      case 'shared':
        return 'text-secondary';
      case 'deleted':
        return 'text-error';
      default:
        return 'text-muted-foreground';
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const diffInMinutes = Math.floor((now - activityTime) / (1000 * 60));
    
    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours}h ago`;
    
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) return `${diffInDays}d ago`;
    
    return activityTime?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const formatActivityDescription = (activity) => {
    // Extract trip name from description or use trip destination
    const tripName = activity?.trip?.destination || 
                     activity?.description?.match(/"([^"]+)"/)?.[1] || 
                     'a trip';
    
    return {
      action: activity?.description || 'Activity recorded',
      tripName: tripName
    };
  };

  return (
    <div className="bg-card border border-border rounded-organic shadow-organic p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-heading-bold text-lg text-card-foreground">
          Recent Activity
        </h3>
        <Icon name="Activity" size={20} className="text-muted-foreground" />
      </div>
      <div className="space-y-4">
        {!activities || activities?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Calendar" size={48} className="text-muted-foreground mx-auto mb-3" />
            <p className="font-body text-muted-foreground">No recent activity</p>
            <p className="font-caption text-xs text-muted-foreground mt-1">
              Your trip actions will appear here
            </p>
          </div>
        ) : (
          activities?.map((activity) => {
            const { action, tripName } = formatActivityDescription(activity);
            
            return (
              <div 
                key={activity?.id} 
                className="flex items-start space-x-3 p-3 hover:bg-muted rounded-organic-sm transition-organic"
              >
                <div className={`flex-shrink-0 w-8 h-8 rounded-full bg-background border border-border flex items-center justify-center ${getActivityColor(activity?.activityType)}`}>
                  <Icon name={getActivityIcon(activity?.activityType)} size={14} />
                </div>
                
                <div className="flex-1 min-w-0">
                  <p className="font-body text-sm text-card-foreground">
                    {action}
                  </p>
                  <p className="font-caption text-xs text-muted-foreground mt-1">
                    {formatTimeAgo(activity?.createdAt)}
                  </p>
                </div>

                {activity?.activityType === 'shared' && activity?.metadata?.shareCount && (
                  <div className="flex-shrink-0">
                    <span className="inline-flex items-center px-2 py-1 bg-secondary/10 text-secondary rounded-full text-xs">
                      <Icon name="Users" size={10} className="mr-1" />
                      {activity?.metadata?.shareCount}
                    </span>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
      {activities && activities?.length > 0 && (
        <div className="mt-4 pt-4 border-t border-border">
          <button className="w-full text-center font-body text-sm text-primary hover:text-primary/80 transition-organic">
            View All Activity
          </button>
        </div>
      )}
    </div>
  );
};

export default RecentActivity;